export enum NotaryStatusKey {
  NEW = 'new',
  ACCOUNT_OPENING = 'account_opening',
  INSTRUCTIONS = 'instructions',
  DRAFTING = 'drafting',
  SIGNATURE = 'signature',
  COMPLETED = 'completed',
  WAITING_ON_CLIENT = 'waiting_on_client',
  SUSPENDED = 'suspended',
  NON_RESPONSIVE = 'non_responsive',
  INCOMPLETE = 'incomplete'
}
